<template>
  <div class="device-list">
    <el-card>
      <div slot="header" class="card-header">
        <span>设备列表</span>
        <div>
          <el-button type="warning" size="small" @click="handleBatchOta">
            <i class="el-icon-upload"></i> 批量升级{{ selectedDevices.length ? '（已选 ' + selectedDevices.length + ' 台）' : '' }}
          </el-button>
          <el-button type="primary" size="small" @click="handleAdd">
            <i class="el-icon-plus"></i> 添加设备
          </el-button>
        </div>
      </div>
      
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="设备名称">
          <el-input v-model="searchForm.name" placeholder="请输入设备名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="序列号">
          <el-input v-model="searchForm.serialNumber" placeholder="请输入序列号" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select v-model="searchForm.deviceType" placeholder="请选择设备类型" clearable filterable style="width: 160px;">
            <el-option v-for="type in deviceTypes" :key="type.id" :label="type.name" :value="type.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable>
            <el-option label="在线" value="online"></el-option>
            <el-option label="离线" value="offline"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table ref="deviceTable" :data="deviceList" :key="tableKey" :row-key="'id'" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column type="index" label="序号" width="80" :index="indexMethod"></el-table-column>
        <el-table-column prop="name" label="设备名称" width="150"></el-table-column>
        <el-table-column prop="deviceType" label="设备类型" width="120"></el-table-column>
        <el-table-column prop="serialNumber" label="序列号" width="180"></el-table-column>
        <el-table-column prop="iccid" label="ICCID" width="180"></el-table-column>
        <el-table-column prop="networkType" label="联网方式" width="120"></el-table-column>
        <el-table-column prop="signalStrength" label="信号强度" width="120">
          <template slot-scope="scope">
            {{ scope.row.signalStrength || 0 }} dBm
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'online' ? 'success' : 'danger'" size="small">
              {{ scope.row.status === 'online' ? '在线' : '离线' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="firmwareVersion" label="固件版本" width="110">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.firmwareVersion" type="warning" size="small">v{{ scope.row.firmwareVersion }}</el-tag>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="activationDate" label="激活日期" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.activationDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="lastOnline" label="最后在线" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.lastOnline) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="270" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleView(scope.row)">查看</el-button>
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" style="color: #e6a23c;" @click="handleOta(scope.row)">升级</el-button>
            <el-button v-if="scope.row.pendingUpgrade" size="mini" type="text"
                       style="color: #f56c6c;" @click="handleCancelUpgrade(scope.row)">取消升级</el-button>
            <el-button size="mini" type="text" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right;"
      >
      </el-pagination>
    </el-card>

    <!-- 设备编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="deviceForm" :rules="deviceRules" ref="deviceForm" label-width="100px">
        <el-form-item label="设备名称" prop="name">
          <el-input v-model="deviceForm.name" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="deviceType">
          <el-select v-model="deviceForm.deviceType" placeholder="请选择设备类型" style="width: 100%;">
            <el-option
              v-for="type in deviceTypes"
              :key="type.id"
              :label="type.name"
              :value="type.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备模板*" prop="templateId">
          <el-select v-model="deviceForm.templateId" placeholder="请选择设备模板" style="width: 100%;" :disabled="isEditMode">
            <el-option
              v-for="template in deviceTemplates"
              :key="template.id"
              :label="template.name"
              :value="template.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="序列号" prop="serialNumber">
          <el-input v-model="deviceForm.serialNumber" placeholder="请输入序列号" :disabled="isEditMode"></el-input>
        </el-form-item>
        <el-form-item label="ICCID">
          <el-input v-model="deviceForm.iccid" placeholder="请输入ICCID"></el-input>
        </el-form-item>
        <el-form-item label="联网方式">
          <el-select v-model="deviceForm.networkType" placeholder="请选择联网方式" style="width: 100%;">
            <el-option label="WiFi" value="wifi"></el-option>
            <el-option label="4G" value="4g"></el-option>
            <el-option label="5G" value="5g"></el-option>
            <el-option label="LoRa" value="lora"></el-option>
            <el-option label="NB-IoT" value="nb-iot"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="信号强度">
          <el-input v-model.number="deviceForm.signalStrength" placeholder="请输入信号强度(dBm)" type="number"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="deviceForm.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="设备密码">
          <el-input v-model="deviceForm.devicePassword" placeholder="系统会自动生成密码"></el-input>
        </el-form-item>
        <el-form-item label="密码验证">
          <el-switch v-model="deviceForm.passwordRequired" active-text="需要" inactive-text="不需要"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 设备详情抽屉 -->
    <el-drawer
      title="设备详情"
      :visible.sync="detailDrawerVisible"
      direction="rtl"
      size="80%"
      :with-header="true"
    >
      <div v-if="currentDevice" class="device-detail">
        <div class="device-basic-info">
          <h3>基本信息</h3>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="设备名称">{{ currentDevice.name }}</el-descriptions-item>
            <el-descriptions-item label="设备类型">{{ currentDevice.deviceType }}</el-descriptions-item>
            <el-descriptions-item label="序列号">{{ currentDevice.serialNumber }}</el-descriptions-item>
            <el-descriptions-item label="ICCID">{{ currentDevice.iccid || '-' }}</el-descriptions-item>
            <el-descriptions-item label="联网方式">{{ currentDevice.networkType || '-' }}</el-descriptions-item>
            <el-descriptions-item label="信号强度">{{ currentDevice.signalStrength || 0 }} dBm</el-descriptions-item>
            <el-descriptions-item label="设备状态">
              <el-tag :type="currentDevice.status === 'online' ? 'success' : 'danger'" size="small">
                {{ currentDevice.status === 'online' ? '在线' : '离线' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="固件版本">
              <el-tag v-if="currentDevice.firmwareVersion" type="warning" size="small">v{{ currentDevice.firmwareVersion }}</el-tag>
              <span v-else>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="激活日期">{{ formatDate(currentDevice.activationDate) }}</el-descriptions-item>
            <el-descriptions-item label="最后在线">{{ formatDate(currentDevice.lastOnline) }}</el-descriptions-item>
            <el-descriptions-item label="设备密码">
              <div class="password-container">
                <span>{{ currentDevice.devicePassword || '-' }}</span>
                <el-button type="text" size="small" @click="handleResetPassword" style="margin-left: 10px;">
                  重置
                </el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="密码验证">
              <el-tag :type="currentDevice.passwordRequired ? 'success' : 'info'" size="small">
                {{ currentDevice.passwordRequired ? '需要' : '不需要' }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div class="device-sensor-data">
          <h3>变量参数</h3>
          
          <!-- 变量列表 -->
          <el-table :data="sensorDataList" border style="width: 100%">
            <el-table-column prop="variableId" label="变量ID" width="120"></el-table-column>
            <el-table-column prop="variableType" label="变量类型" width="130">
              <template slot-scope="scope">
                <el-tag size="small" :type="getVariableTypeTag(scope.row.variableType)">
                  {{ getVariableTypeDesc(scope.row.variableType) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="dataType" label="数据类型" width="120">
              <template slot-scope="scope">
                <span>{{ getDataTypeDesc(scope.row.dataType) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="accessMode" label="读写权限" width="100">
              <template slot-scope="scope">
                <el-tag size="small" :type="scope.row.accessMode === 'readwrite' ? 'success' : 'info'">
                  {{ scope.row.accessMode === 'readwrite' ? '读写' : '只读' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="variableName" label="变量名称" width="120"></el-table-column>
            <el-table-column prop="updateTime" label="更新时间" width="180">
              <template slot-scope="scope">
                {{ formatDateTime(scope.row.updateTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="currentValue" label="当前值" width="150">
              <template slot-scope="scope">
                {{ scope.row.currentValue }} {{ scope.row.unit }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="handleHistoryQuery(scope.row)">历史查询</el-button>
                <!-- 命令类型变量直接在表格中控制 -->
                <template v-if="isControllable(scope.row.variableType, scope.row.accessMode)">
                  <el-switch
                    v-if="scope.row.dataType === 'boolean'"
                    :value="scope.row.switchValue"
                    @click.native="handleDirectControl(scope.row)"
                    :loading="controlLoading[scope.row.variableId]"
                    style="transform: scale(1.2); margin-left: 20px"
                  />
                  <el-switch
                    v-else-if="scope.row.dataType === 'number' || scope.row.dataType === 'integer' || scope.row.dataType === 'float'"
                    :value="scope.row.switchValue"
                    @click.native="handleDirectControl(scope.row)"
                    :loading="controlLoading[scope.row.variableId]"
                    style="transform: scale(1.2); margin-left: 20px"
                  />
                  <el-input
                    v-else
                    v-model="scope.row.inputValue"
                    :placeholder="'输入'"
                    style="width: 120px; margin-left: 10px"
                    @blur="handleDirectControl(scope.row)"
                    :loading="controlLoading[scope.row.variableId]"
                  />
                </template>
              </template>
            </el-table-column>
          </el-table>
          
          <!-- 空状态 -->
          <el-empty v-if="sensorDataList.length === 0" description="暂无变量参数"></el-empty>
        </div>

        <div class="device-members">
          <h3>绑定成员 ({{ members.length }}/{{ maxMembers }})</h3>
          <el-table :data="members" border style="width: 100%" v-loading="membersLoading">
            <el-table-column prop="userId" label="用户ID" width="120"></el-table-column>
            <el-table-column prop="nickname" label="昵称">
              <template slot-scope="scope">
                {{ scope.row.nickname || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="role" label="角色" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.role === 'owner' ? 'warning' : 'info'" size="small">
                  {{ scope.row.role === 'owner' ? '所有者' : '成员' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="addedAt" label="绑定时间" width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.addedAt) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.role !== 'owner'"
                  size="mini" type="text" class="danger-text"
                  @click="handleRemoveMember(scope.row)">移除</el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <el-empty v-if="members.length === 0 && !membersLoading" description="暂无绑定成员"></el-empty>
        </div>
      </div>
    </el-drawer>

    <!-- 设备变量控制对话框 -->
    <el-dialog
      :title="'控制 ' + controlForm.variableName"
      :visible.sync="controlDialogVisible"
      width="500px"
      @close="handleControlDialogClose"
    >
      <el-form :model="controlForm" label-width="100px">
        <el-form-item label="变量ID" prop="variableId">
          <el-input v-model="controlForm.variableId" disabled></el-input>
        </el-form-item>
        <el-form-item label="变量类型">
          <el-tag :type="getVariableTypeTag(controlForm.variableType)" size="small">
            {{ getVariableTypeDesc(controlForm.variableType) }}
          </el-tag>
        </el-form-item>
        <el-form-item label="数据类型">
          <span>{{ getDataTypeDesc(controlForm.dataType) }}</span>
        </el-form-item>
        <el-form-item label="当前值" prop="currentValue">
          <el-input :value="controlForm.currentValue + ' ' + (controlForm.unit || '')" disabled></el-input>
        </el-form-item>
        <el-form-item label="新值" prop="newValue" required>
          <el-input-number 
            v-if="controlForm.dataType === 'number' || controlForm.dataType === 'integer' || controlForm.dataType === 'float'"
            v-model="controlForm.newValue" 
            :placeholder="'请输入' + getDataTypeDesc(controlForm.dataType)"
            style="width: 100%"
            :precision="controlForm.dataType === 'integer' ? 0 : 2"
          ></el-input-number>
          <el-switch
            v-else-if="controlForm.dataType === 'boolean'"
            v-model="controlForm.newValue"
            active-text="开启"
            inactive-text="关闭"
          ></el-switch>
          <el-input 
            v-else
            v-model="controlForm.newValue" 
            :placeholder="'请输入' + getDataTypeDesc(controlForm.dataType)"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="controlDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleControlSubmit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="'历史数据 - ' + historyForm.variableName"
      :visible.sync="historyDialogVisible"
      width="800px"
      @close="handleHistoryDialogClose"
    >
      <div class="history-filter">
        <el-radio-group v-model="historyForm.timeRange" @change="handleTimeRangeChange">
          <el-radio-button label="1">最近1小时</el-radio-button>
          <el-radio-button label="6">最近6小时</el-radio-button>
          <el-radio-button label="24">最近24小时</el-radio-button>
          <el-radio-button label="72">最近3天</el-radio-button>
          <el-radio-button label="168">最近7天</el-radio-button>
        </el-radio-group>
      </div>
      
      <div v-loading="historyLoading" class="history-content">
        <div v-if="historyData.length > 0">
          <div class="history-chart" ref="historyChart" style="height: 300px;"></div>
          <el-table :data="historyData" border style="width: 100%; margin-top: 20px;" max-height="300">
            <el-table-column prop="recordTime" label="记录时间" width="180">
              <template slot-scope="scope">
                {{ formatDateTime(scope.row.recordTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="recordValue" label="数值">
              <template slot-scope="scope">
                {{ scope.row.recordValue }} {{ scope.row.unit }}
              </template>
            </el-table-column>
            <el-table-column prop="dataSource" label="数据来源" width="100"></el-table-column>
          </el-table>
        </div>
        <el-empty v-else description="暂无历史数据"></el-empty>
      </div>
      
      <div slot="footer">
        <el-button @click="historyDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- OTA 远程升级对话框 -->
    <el-dialog title="远程升级 (OTA)" :visible.sync="otaDialogVisible" width="600px" :close-on-click-modal="false">
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="设备名称">{{ otaForm.deviceName }}</el-descriptions-item>
        <el-descriptions-item label="序列号">{{ otaForm.serialNumber }}</el-descriptions-item>
        <el-descriptions-item label="设备状态">
          <el-tag :type="otaForm.status === 'online' ? 'success' : 'danger'" size="small">
            {{ otaForm.status === 'online' ? '在线' : '离线' }}
          </el-tag>
          <span v-if="otaForm.status !== 'online'" style="margin-left: 8px; color: #909399; font-size: 12px;">
            离线设备上线后将自动开始升级
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="当前版本">
          <el-tag v-if="otaForm.currentVersion" type="success" size="small">v{{ otaForm.currentVersion }}</el-tag>
          <span v-else style="color: #909399;">未知（设备上线后会自动上报）</span>
        </el-descriptions-item>
      </el-descriptions>

      <el-form label-width="100px" style="margin-top: 18px;">
        <el-form-item label="选择固件" required>
          <el-select v-model="otaForm.firmwareId" placeholder="请选择要升级的固件包"
                     :disabled="otaDeploying" filterable style="width: 100%;">
            <el-option v-for="fw in firmwareList" :key="fw.id"
              :label="fw.originalName"
              :value="fw.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <!-- 升级进度 -->
      <div v-if="otaProgress.show" style="margin: 5px 20px 15px;">
        <el-progress :percentage="otaProgress.progress" :status="otaProgressStatus"></el-progress>
        <div style="margin-top: 8px; color: #606266; font-size: 13px;">{{ otaProgress.message }}</div>
      </div>

      <!-- 最近升级记录 -->
      <div v-if="otaRecords.length > 0" style="margin: 10px 20px 0;">
        <div style="font-weight: bold; margin-bottom: 10px; color: #303133;">最近升级记录</div>
        <el-timeline>
          <el-timeline-item v-for="rec in otaRecords.slice(0, 3)" :key="rec.id"
            :type="otaRecordTagType(rec.status)" :timestamp="formatDate(rec.createTime)">
            <span style="font-size: 13px;">v{{ rec.version }} - {{ otaRecordStatusText(rec.status) }}</span>
            <div v-if="rec.message" style="color: #909399; font-size: 12px; margin-top: 2px;">{{ rec.message }}</div>
          </el-timeline-item>
        </el-timeline>
      </div>

      <div slot="footer">
        <el-button @click="otaDialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="otaDeploying" :disabled="otaDeploying" @click="handleDeploy">
          {{ otaDeploying ? '升级进行中...' : '一键升级' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 批量升级 (OTA) 对话框 -->
    <el-dialog title="批量升级 (OTA)" :visible.sync="batchOtaDialogVisible" width="780px" :close-on-click-modal="false">
      <!-- 阶段一：确认设备与固件 -->
      <template v-if="batchPhase === 'select'">
        <div style="margin-bottom: 12px; color: #606266; font-size: 13px; display: flex; justify-content: space-between; align-items: center;">
          <span>
            已选择 <b>{{ batchTargets.length }}</b> 台设备，其中
            <span :style="{ color: offlineBatchCount > 0 ? '#F56C6C' : '#67C23A', fontWeight: 'bold' }">{{ offlineBatchCount }}</span>
            台离线（离线设备下发会失败）
          </span>
          <el-button type="text" size="small" :loading="batchSelectingAll" @click="handleSelectAllFiltered">
            <i class="el-icon-finished"></i> 全选当前搜索结果
          </el-button>
        </div>
        <el-table :data="batchTargets" size="small" border max-height="220">
          <el-table-column prop="name" label="设备名称" min-width="130" show-overflow-tooltip></el-table-column>
          <el-table-column prop="serialNumber" label="序列号" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="当前版本" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.firmwareVersion">v{{ scope.row.firmwareVersion }}</span>
              <span v-else style="color: #c0c4cc;">-</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'online' ? 'success' : 'danger'" size="small">
                {{ scope.row.status === 'online' ? '在线' : '离线' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
        <el-form label-width="100px" style="margin-top: 16px;">
          <el-form-item label="选择固件" required>
            <el-select v-model="batchForm.firmwareId" placeholder="请选择要升级的固件包"
                       :disabled="batchDeploying" filterable style="width: 100%;">
              <el-option v-for="fw in firmwareList" :key="fw.id"
                :label="fw.originalName"
                :value="fw.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>

      <!-- 阶段二：下发后逐台进度 -->
      <template v-else>
        <el-table :data="batchProgressList" size="small" border max-height="400">
          <el-table-column prop="deviceName" label="设备名称" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="serialNumber" label="序列号" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column label="升级进度" min-width="170">
            <template slot-scope="scope">
              <el-progress :percentage="Number(scope.row.progress) || 0"
                           :status="batchProgressStatus(scope.row.status)"></el-progress>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="otaRecordTagType(scope.row.status)" size="small">
                {{ otaRecordStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="message" label="详情" min-width="150" show-overflow-tooltip></el-table-column>
        </el-table>
      </template>

      <div slot="footer">
        <el-button @click="batchOtaDialogVisible = false">{{ batchPhase === 'deploying' ? '关闭' : '取消' }}</el-button>
        <el-button v-if="batchPhase === 'select'" type="primary" :loading="batchDeploying" @click="handleBatchDeploy">
          {{ batchDeploying ? '下发中...' : '批量下发升级' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'DeviceList',
  data() {
    return {
      searchForm: {
        name: '',
        serialNumber: '',
        status: ''
      },
      deviceList: [],
      tableKey: 0,
      deviceTypes: [],
      deviceTemplates: [],
      loading: false,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '添加设备',
      isEditMode: false,
      deviceForm: {
        id: null,
        name: '',
        deviceType: '',
        templateId: null,
        serialNumber: '',
        iccid: '',
        networkType: '',
        signalStrength: null,
        activationDate: null,
        remark: '',
        devicePassword: '',
        passwordRequired: true
      },
      deviceRules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        deviceType: [{ required: true, message: '请选择设备类型', trigger: 'change' }],
        templateId: [{ required: true, message: '请选择设备模板', trigger: 'change' }],
        serialNumber: [{ required: true, message: '请输入序列号', trigger: 'blur' }]
      },
      // 设备详情抽屉相关
      detailDrawerVisible: false,
      currentDevice: null,
      // 存储变量参数列表
      sensorDataList: [],
      // 设备控制相关
      controlDialogVisible: false,
      controlForm: {
        variableId: '',
        variableName: '',
        variableType: '',
        dataType: '',
        currentValue: '',
        unit: '',
        newValue: ''
      },
      historyDialogVisible: false,
      historyLoading: false,
      historyData: [],
      historyForm: {
        deviceId: null,
        variableId: '',
        variableName: '',
        timeRange: '24'
      },
      // 控制加载状态
      controlLoading: {},
      waitingForResponse: false,
      ws: null,
      wsReconnectTimer: null,
      // 设备成员管理
      members: [],
      maxMembers: 5,
      membersLoading: false,
      // OTA 远程升级相关
      firmwareList: [],
      otaDialogVisible: false,
      otaDeploying: false,
      otaForm: {
        deviceId: null,
        deviceName: '',
        serialNumber: '',
        currentVersion: '',
        firmwareId: null
      },
      otaProgress: {
        show: false,
        progress: 0,
        status: '',
        message: ''
      },
      otaRecords: [],
      // 批量升级相关
      selectedDevices: [],
      batchOtaDialogVisible: false,
      batchDeploying: false,
      batchForm: {
        firmwareId: null
      },
      batchPhase: 'select', // select: 确认设备与固件；deploying: 逐台进度展示
      batchTargets: [],     // 本次批量升级的目标设备（可来自勾选或「全选当前搜索结果」）
      batchSelectingAll: false,
      batchProgressList: [],
      batchFinishedNotified: false
    }
  },
  computed: {
    // 升级进度条状态：失败红色、成功绿色、进行中蓝色(null)
    otaProgressStatus() {
      if (this.otaProgress.status === 'failed') return 'exception'
      if (this.otaProgress.status === 'success') return 'success'
      return null
    },
    // 批量升级目标设备中的离线数量
    offlineBatchCount() {
      return this.batchTargets.filter(d => d.status !== 'online').length
    }
  },
  mounted() {
    this.fetchDeviceTypes()
    this.fetchDeviceTemplates()
    this.fetchDevices()
    this.connectWebSocket()
  },
  beforeDestroy() {
    this.disconnectWebSocket()
  },
  methods: {
    async fetchDevices() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          size: this.pagination.size,
          ...this.searchForm
        }
        const res = await api.getDevices(params)
        this.deviceList = res.data || []
        this.pagination.total = res.total || 0
      } catch (error) {
        this.$message.error('获取设备列表失败')
        this.deviceList = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    async fetchDeviceTypes() {
      try {
        const res = await api.getDeviceTypes()
        // 从响应中提取data字段作为设备类型列表
        this.deviceTypes = res.data || []
      } catch (error) {
        this.$message.error('获取设备类型列表失败')
        this.deviceTypes = []
      }
    },
    async fetchDeviceTemplates() {
      try {
        const res = await api.getDeviceTemplates()
        // 从响应中提取data字段作为设备模板列表
        this.deviceTemplates = res.data || []
      } catch (error) {
        this.$message.error('获取设备模板列表失败')
        this.deviceTemplates = []
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchDevices()
    },
    handleReset() {
      this.searchForm = { name: '', serialNumber: '', deviceType: '', status: '' }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchDevices()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchDevices()
    },
    handleAdd() {
      this.dialogTitle = '添加设备'
      this.isEditMode = false
      this.deviceForm = {
        id: null,
        name: '',
        deviceType: '',
        templateId: null,
        serialNumber: '',
        iccid: '',
        networkType: '',
        signalStrength: null,
        activationDate: null,
        remark: '',
        devicePassword: '',
        passwordRequired: true
      }
      // 刷新设备类型和模板列表
      this.fetchDeviceTypes()
      this.fetchDeviceTemplates()
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑设备'
      this.isEditMode = true
      this.deviceForm = JSON.parse(JSON.stringify(row))
      // 转换日期格式
      if (row.activationDate && typeof row.activationDate === 'string') {
        this.deviceForm.activationDate = new Date(row.activationDate)
      }
      // 确保密码验证字段有默认值
      if (this.deviceForm.passwordRequired === undefined) {
        this.deviceForm.passwordRequired = true
      }
      // 刷新设备类型列表
      this.fetchDeviceTypes()
      this.dialogVisible = true
    },
    handleView(row) {
      this.currentDevice = row
      if (row.variables && row.variables.length > 0) {
        this.sensorDataList = row.variables.map(variable => {
          const currentValue = variable.currentValue || variable.defaultValue || '0'
          return {
            variableId: variable.variableId,
            variableType: variable.variableType || 'property',
            dataType: variable.dataType || 'string',
            accessMode: variable.accessMode || 'readonly',
            variableName: variable.variableName,
            updateTime: variable.updateTime || row.lastOnline || '',
            currentValue: currentValue,
            unit: variable.unit || '',
            // 初始化控制值
            switchValue: (variable.dataType === 'boolean' || variable.dataType === 'number' || variable.dataType === 'integer' || variable.dataType === 'float') ? (currentValue === '1' || currentValue === 'true' || currentValue === '开启') : false,
            inputValue: (variable.dataType !== 'boolean' && variable.dataType !== 'number' && variable.dataType !== 'integer' && variable.dataType !== 'float') ? currentValue : ''
          }
        })
      } else {
        this.parseDeviceData(row.data)
      }
      this.loadMembers(row.id)
      this.detailDrawerVisible = true
    },
    // 加载设备绑定成员
    async loadMembers(deviceId) {
      this.membersLoading = true
      try {
        const res = await api.getDeviceMembers(deviceId)
        this.members = res.data || []
        this.maxMembers = res.max || 5
      } catch (error) {
        console.error('获取成员列表失败:', error)
        this.members = []
      } finally {
        this.membersLoading = false
      }
    },
    // 管理员移除设备成员
    handleRemoveMember(row) {
      this.$confirm(`确定要移除成员"${row.nickname || row.userId}"吗？移除后该账号将无法再使用此设备。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.removeDeviceMember(this.currentDevice.id, row.userId)
          .then(() => {
            this.$message.success('成员已移除')
            this.loadMembers(this.currentDevice.id)
          })
          .catch((error) => {
            console.error('移除成员失败:', error)
            this.$message.error('移除失败：' + (error.response?.data?.message || error.message))
          })
      }).catch(() => {})
    },
    connectWebSocket() {
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
      const wsUrl = `${protocol}//${window.location.host}/ws/devices`
      
      this.disconnectWebSocket()
      
      this.ws = new WebSocket(wsUrl)
      
      this.ws.onopen = () => {
        console.log('WebSocket连接成功')
        if (this.wsReconnectTimer) {
          clearTimeout(this.wsReconnectTimer)
          this.wsReconnectTimer = null
        }
      }
      
      this.ws.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data)
          this.handleWebSocketMessage(message)
        } catch (e) {
          console.error('WebSocket消息解析失败:', e)
        }
      }
      
      this.ws.onerror = () => {
        console.error('WebSocket连接错误')
        this.scheduleReconnect()
      }
      
      this.ws.onclose = () => {
        console.log('WebSocket连接关闭')
        this.scheduleReconnect()
      }
    },
    disconnectWebSocket() {
      if (this.ws) {
        this.ws.close()
        this.ws = null
      }
      if (this.wsReconnectTimer) {
        clearTimeout(this.wsReconnectTimer)
        this.wsReconnectTimer = null
      }
    },
    scheduleReconnect() {
      if (this.wsReconnectTimer) return
      this.wsReconnectTimer = setTimeout(() => {
        console.log('尝试重新连接WebSocket...')
        this.connectWebSocket()
      }, 5000)
    },
    handleWebSocketMessage(message) {
      if (message.type === 'device_update') {
        this.updateDeviceStatus(message)
      } else if (message.type === 'ota_progress') {
        this.handleOtaProgress(message)
      }
    },
    updateDeviceStatus(update) {
      const deviceIndex = this.deviceList.findIndex(d => 
        d.id === update.deviceId || 
        String(d.id) === String(update.deviceId) || 
        d.serialNumber === update.serialNumber
      )
      if (deviceIndex >= 0) {
        const newStatus = update.online ? 'online' : 'offline'
        const oldStatus = this.deviceList[deviceIndex].status
        if (oldStatus !== newStatus) {
          this.$set(this.deviceList[deviceIndex], 'status', newStatus)
          this.$set(this.deviceList[deviceIndex], 'lastOnline', update.lastOnline)
          console.log('设备状态更新:', oldStatus, '->', newStatus, '设备索引:', deviceIndex)
        }

        // 固件版本号更新（设备心跳/上线携带，升级完成后变为新版本）
        if (update.firmwareVersion && update.firmwareVersion !== this.deviceList[deviceIndex].firmwareVersion) {
          this.$set(this.deviceList[deviceIndex], 'firmwareVersion', update.firmwareVersion)
          console.log('设备固件版本更新:', update.firmwareVersion)
        }

        if (this.currentDevice && (this.currentDevice.id === update.deviceId || this.currentDevice.serialNumber === update.serialNumber)) {
          this.currentDevice = {
            ...this.currentDevice,
            online: update.online,
            lastOnline: update.lastOnline
          }
          
          if (update.data && this.detailDrawerVisible) {
            let hasVariableUpdate = false
            this.sensorDataList = this.sensorDataList.map(item => {
              if (update.data[item.variableId] !== undefined) {
                const newValue = update.data[item.variableId]
                hasVariableUpdate = true
                this.controlLoading[item.variableId] = false
                return {
                  ...item,
                  currentValue: newValue,
                  switchValue: (item.dataType === 'boolean' || item.dataType === 'number' || item.dataType === 'integer' || item.dataType === 'float') ? (newValue === '1' || newValue === 'true' || newValue === '开启') : false
                }
              }
              return item
            })
            if (hasVariableUpdate && this.waitingForResponse) {
              this.$message.success('设备响应成功')
              this.waitingForResponse = false
            }
          }
        }
      }
    },
    // 解析设备数据，生成sensorDataList
    parseDeviceData(dataStr) {
      const paramMap = {
        temperature: '温度',
        temp: '温度',
        humidity: '湿度',
        hum: '湿度',
        light: '光照',
        noise: '噪音',
        air: '大气压',
        '0.5um': '0.5μm',
        '1um': '1μm',
        '5um': '5μm'
      }
      
      const unitMap = {
        temperature: '℃',
        temp: '℃',
        humidity: '%',
        hum: '%',
        light: 'lux',
        noise: 'dB',
        air: 'kpa',
        '0.5um': 'pc/m³',
        '1um': 'pc/m³',
        '5um': 'pc/m³'
      }
      
      this.sensorDataList = []
      if (dataStr && dataStr.trim() !== '') {
        const dataPairs = dataStr.split(',')
        
        dataPairs.forEach(pair => {
          const [key, value] = pair.split(':').map(item => item.trim())
          if (key && value) {
            const paramName = paramMap[key] || key
            const unit = unitMap[key] || ''
            const displayValue = unit ? `${value} ${unit}` : value
            
            this.sensorDataList.push({
              variableId: key,
              variableType: 'property',
              dataType: 'number',
              variableName: paramName,
              updateTime: this.formatDate(this.currentDevice.lastOnline),
              currentValue: displayValue,
              rawValue: value,
              unit: unit
            })
          }
        })
      }
    },
    handleHistoryQuery(sensorData) {
      this.historyForm = {
        deviceId: this.currentDevice.id,
        variableId: sensorData.variableId,
        variableName: sensorData.variableName,
        timeRange: '24'
      }
      this.historyDialogVisible = true
      this.loadHistoryData()
    },
    async loadHistoryData() {
      this.historyLoading = true
      try {
        const res = await api.getVariableRecentHistory(
          this.historyForm.deviceId,
          this.historyForm.variableId,
          parseInt(this.historyForm.timeRange)
        )
        if (res.success) {
          this.historyData = res.data || []
          this.$nextTick(() => {
            if (this.historyData.length > 0) {
              this.renderChart()
            }
          })
        } else {
          this.$message.error(res.message || '查询历史数据失败')
          this.historyData = []
        }
      } catch (error) {
        this.$message.error('查询历史数据失败')
        this.historyData = []
      } finally {
        this.historyLoading = false
      }
    },
    handleTimeRangeChange() {
      this.loadHistoryData()
    },
    renderChart() {
      const chartDom = this.$refs.historyChart
      if (!chartDom) return
      
      const times = this.historyData.map(item => this.formatDateTime(item.recordTime))
      const values = this.historyData.map(item => parseFloat(item.recordValue) || 0)
      const unit = this.historyData[0]?.unit || ''
      
      const option = {
        title: {
          text: this.historyForm.variableName + ' 历史趋势',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>数值: {c}' + unit
        },
        xAxis: {
          type: 'category',
          data: times,
          axisLabel: {
            rotate: 45,
            interval: Math.floor(times.length / 10)
          }
        },
        yAxis: {
          type: 'value',
          name: unit
        },
        series: [{
          data: values,
          type: 'line',
          smooth: true,
          itemStyle: {
            color: '#409EFF'
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: 'rgba(64, 158, 255, 0.3)'
              }, {
                offset: 1,
                color: 'rgba(64, 158, 255, 0.05)'
              }]
            }
          }
        }],
        grid: {
          left: '10%',
          right: '10%',
          bottom: '20%',
          top: '15%'
        }
      }
      
      if (this.chart) {
        this.chart.dispose()
      }
      this.chart = this.$echarts.init(chartDom)
      this.chart.setOption(option)
    },
    handleHistoryDialogClose() {
      this.historyData = []
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
    },
    formatDateTime(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const seconds = date.getSeconds().toString().padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    handleControlVariable(sensorData) {
      let newValue = ''
      if (sensorData.dataType === 'boolean') {
        newValue = sensorData.currentValue === 'true' || sensorData.currentValue === '1'
      } else if (sensorData.dataType === 'number' || sensorData.dataType === 'integer' || sensorData.dataType === 'float') {
        newValue = parseFloat(sensorData.currentValue) || 0
      }
      
      this.controlForm = {
        variableId: sensorData.variableId,
        variableName: sensorData.variableName,
        variableType: sensorData.variableType,
        dataType: sensorData.dataType,
        currentValue: sensorData.currentValue,
        unit: sensorData.unit,
        newValue: newValue
      }
      this.controlDialogVisible = true
    },
    async handleControlSubmit() {
      console.log('handleControlSubmit - controlForm:', this.controlForm)
      
      if (this.controlForm.newValue === '' || this.controlForm.newValue === null) {
        this.$message.error('请输入新值')
        return
      }
      
      let sendValue = this.controlForm.newValue
      
      if (this.controlForm.dataType === 'boolean') {
        sendValue = sendValue ? '1' : '0'
      } else if (this.controlForm.dataType === 'number' || this.controlForm.dataType === 'integer' || this.controlForm.dataType === 'float') {
        sendValue = String(sendValue)
      }
      
      console.log('发送到后端的数据:', {
        deviceId: this.currentDevice.id,
        variableId: this.controlForm.variableId,
        value: sendValue,
        dataType: this.controlForm.dataType
      })
      
      try {
        const res = await api.updateDeviceVariable(this.currentDevice.id, this.controlForm.variableId, sendValue)
        console.log('API响应:', res)
        this.$message.success('变量控制命令发送成功')
        this.controlDialogVisible = false
        this.handleView(this.currentDevice)
      } catch (error) {
        console.error('API调用错误:', error)
        this.$message.error('变量控制命令发送失败：' + (error.response?.data?.message || error.message))
      }
    },
    handleControlDialogClose() {
      this.controlForm = {
        variableId: '',
        variableName: '',
        variableType: '',
        dataType: '',
        currentValue: '',
        unit: '',
        newValue: ''
      }
    },
    async handleDirectControl(variable) {
      console.log('handleDirectControl - variable:', variable)
      
      let sendValue
      if (variable.dataType === 'boolean' || variable.dataType === 'number' || variable.dataType === 'integer' || variable.dataType === 'float') {
        sendValue = !variable.switchValue
        sendValue = sendValue ? '1' : '0'
      } else {
        sendValue = variable.inputValue
        if (sendValue === '' || sendValue === null) {
          this.$message.error('请输入值')
          return
        }
      }
      
      console.log('发送到后端的数据:', {
        deviceId: this.currentDevice.id,
        variableId: variable.variableId,
        value: sendValue,
        dataType: variable.dataType
      })
      
      this.controlLoading[variable.variableId] = true
      this.waitingForResponse = true
      
      try {
        const res = await api.updateDeviceVariable(this.currentDevice.id, variable.variableId, sendValue)
        console.log('API响应:', res)
        this.$message.success('控制命令已发送，等待设备响应')
      } catch (error) {
        console.error('API调用错误:', error)
        this.$message.error('控制命令发送失败：' + (error.response?.data?.message || error.message))
        this.controlLoading[variable.variableId] = false
        this.waitingForResponse = false
      }
    },
    handleDelete(row) {
      this.$confirm(`确定要删除设备 "${row.name}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        api.deleteDevice(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.fetchDevices()
          })
          .catch(() => {
            this.$message.error('删除失败')
          })
          .finally(() => {
            this.loading = false
          })
      }).catch(() => {})
    },
    handleSubmit() {
      this.$refs.deviceForm.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.deviceForm.id) {
            // 编辑设备
            api.updateDevice(this.deviceForm.id, this.deviceForm)
              .then(() => {
                this.$message.success('编辑成功')
                this.dialogVisible = false
                this.fetchDevices()
              })
              .catch(() => {
                this.$message.error('编辑失败')
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            // 添加设备
            api.addDevice(this.deviceForm)
              .then(() => {
                this.$message.success('添加成功')
                this.dialogVisible = false
                this.fetchDevices()
              })
              .catch(() => {
                this.$message.error('添加失败')
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    },
    handleDialogClose() {
      this.$refs.deviceForm.resetFields()
    },
    indexMethod(index) {
      // 计算当前行在整个数据集中的序号
      return (this.pagination.page - 1) * this.pagination.size + index + 1
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    getVariableTypeDesc(type) {
      const typeMap = {
        'property': '属性',
        'command': '命令',
        'event': '事件'
      }
      return typeMap[type] || type || '属性'
    },
    getVariableTypeTag(type) {
      const tagMap = {
        'property': 'info',
        'command': 'success',
        'event': 'warning'
      }
      return tagMap[type] || 'info'
    },
    getDataTypeDesc(type) {
      const typeMap = {
        'number': '数字',
        'integer': '整数',
        'float': '浮点数',
        'string': '字符串',
        'boolean': '布尔值',
        'json': 'JSON对象'
      }
      return typeMap[type] || type || '字符串'
    },
    isControllable(type, accessMode) {
      if (type === 'command' || type === '命令') {
        return true
      }
      if (type === 'property' || type === '属性') {
        return accessMode === 'readwrite' || accessMode === '读写'
      }
      return false
    },

    // 重置设备密码
    handleResetPassword() {
      this.$confirm('确定要重置设备密码吗？重置后旧密码将失效。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        api.resetDevicePassword(this.currentDevice.id)
          .then((response) => {
            console.log('密码重置响应:', response)
            if (response.success) {
              this.$message.success('密码重置成功，新密码：' + response.newPassword)
              // 更新当前设备展示的密码
              this.currentDevice.devicePassword = response.newPassword
              // 刷新设备列表
              this.fetchDevices()
            } else {
              this.$message.error('密码重置失败：' + (response.message || '未知错误'))
            }
          })
          .catch((error) => {
            console.error('密码重置失败:', error)
            this.$message.error('密码重置失败，请检查网络或联系管理员')
          })
          .finally(() => {
            this.loading = false
          })
      }).catch(() => {})
    },

    // ===== OTA 远程升级 =====

    // 拉取固件列表
    async fetchFirmwares() {
      try {
        const res = await api.getFirmwares()
        this.firmwareList = res.data || []
      } catch (error) {
        console.error('获取固件列表失败:', error)
        this.firmwareList = []
      }
    },

    // 打开升级对话框（离线设备也可下发，上线后自动补发）
    handleOta(row) {
      this.otaForm = {
        deviceId: row.id,
        deviceName: row.name,
        serialNumber: row.serialNumber,
        currentVersion: row.firmwareVersion || '',
        status: row.status,
        firmwareId: null
      }
      this.otaProgress = { show: false, progress: 0, status: '', message: '' }
      this.otaRecords = []
      this.otaDeploying = false
      this.otaDialogVisible = true
      this.fetchFirmwares()
      this.fetchOtaRecords(row.id)
    },

    // 查询设备最近升级记录
    async fetchOtaRecords(deviceId) {
      try {
        const res = await api.getOtaRecords(deviceId)
        this.otaRecords = res.data || []
      } catch (error) {
        console.error('获取升级记录失败:', error)
        this.otaRecords = []
      }
    },

    // 一键下发升级
    handleDeploy() {
      if (!this.otaForm.firmwareId) {
        this.$message.warning('请选择要升级的固件包')
        return
      }
      const fw = this.firmwareList.find(f => f.id === this.otaForm.firmwareId)
      const sameVersion = fw && this.otaForm.currentVersion && fw.version === this.otaForm.currentVersion
      let tip
      if (this.otaForm.status !== 'online') {
        tip = `设备「${this.otaForm.deviceName}」当前离线，下发后将在设备上线时自动开始升级，确定继续吗？`
      } else if (sameVersion) {
        tip = `设备当前已是 v${fw.version}，设备会自动忽略本次升级，仍要下发吗？`
      } else {
        tip = `确定将设备「${this.otaForm.deviceName}」升级到 v${fw ? fw.version : ''} 吗？升级期间设备会自动下载并重启，请保持设备供电。`
      }
      this.$confirm(tip, '升级确认', {
        confirmButtonText: '确定升级',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.otaDeploying = true
        this.otaProgress = { show: true, progress: 0, status: 'pending', message: '升级命令下发中...' }
        api.deployFirmware(this.otaForm.firmwareId, this.otaForm.deviceId)
          .then(res => {
            if (res.success) {
              const msg = (res.data && res.data.message) || '升级命令已下发，等待设备响应'
              this.otaProgress.message = msg
              if (msg.indexOf('离线') >= 0) {
                // 离线设备已排队，不阻塞等待；刷新列表以显示「待升级」标签
                this.otaDeploying = false
                this.$message.info(msg)
                this.fetchDevices()
              } else {
                this.$message.success('升级命令已下发，等待设备响应')
              }
              this.fetchOtaRecords(this.otaForm.deviceId)
            } else {
              this.$message.error(res.message || '升级命令下发失败')
              this.otaDeploying = false
              this.otaProgress.show = false
            }
          })
          .catch(error => {
            this.$message.error('升级命令下发失败：' + (error.response?.data?.message || error.message))
            this.otaDeploying = false
            this.otaProgress.show = false
          })
      }).catch(() => {})
    },

    // ===== 批量升级 =====

    // 表格多选变化
    handleSelectionChange(val) {
      this.selectedDevices = val
    },

    // 打开批量升级对话框（默认带入表格勾选的设备）
    handleBatchOta() {
      this.batchForm.firmwareId = null
      this.batchPhase = 'select'
      this.batchTargets = this.selectedDevices.slice()
      this.batchProgressList = []
      this.batchFinishedNotified = false
      this.batchDeploying = false
      this.batchOtaDialogVisible = true
      this.fetchFirmwares()
    },

    // 按当前搜索条件全选设备（例如按设备类型筛选后一键选中全部匹配设备）
    async handleSelectAllFiltered() {
      this.batchSelectingAll = true
      try {
        const params = { page: 1, size: 1000, ...this.searchForm }
        const res = await api.getDevices(params)
        const list = res.data || []
        if (list.length === 0) {
          this.$message.warning('当前搜索条件下没有设备')
          this.batchTargets = []
          return
        }
        if (res.total > list.length) {
          this.$message.warning(`筛选结果共 ${res.total} 台，已选取前 ${list.length} 台`)
        } else {
          this.$message.success(`已按当前搜索条件选中 ${list.length} 台设备`)
        }
        this.batchTargets = list
      } catch (error) {
        this.$message.error('获取筛选结果失败')
      } finally {
        this.batchSelectingAll = false
      }
    },

    // 批量下发升级
    handleBatchDeploy() {
      if (this.batchTargets.length === 0) {
        this.$message.warning('请先勾选设备或点击「全选当前搜索结果」')
        return
      }
      if (!this.batchForm.firmwareId) {
        this.$message.warning('请选择要升级的固件包')
        return
      }
      const fw = this.firmwareList.find(f => f.id === this.batchForm.firmwareId)
      let tip = `确定将 ${this.batchTargets.length} 台设备批量升级到 v${fw ? fw.version : ''} 吗？在线设备立即升级，离线设备将在上线后自动升级，请保持设备供电。`
      if (this.offlineBatchCount > 0) {
        tip = `有 ${this.offlineBatchCount} 台设备离线，将在其上线后自动升级。` + tip
      }
      this.$confirm(tip, '批量升级确认', {
        confirmButtonText: '确定升级',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchDeploying = true
        const deviceIds = this.batchTargets.map(d => d.id)
        api.deployFirmwareBatch(this.batchForm.firmwareId, deviceIds)
          .then(res => {
            if (res.success) {
              const devMap = {}
              this.batchTargets.forEach(d => { devMap[String(d.id)] = d })
              this.batchProgressList = (res.data.results || []).map(r => {
                const dev = devMap[String(r.deviceId)] || {}
                return {
                  deviceId: r.deviceId,
                  deviceName: r.deviceName || dev.name || ('设备' + r.deviceId),
                  serialNumber: r.serialNumber || dev.serialNumber || '-',
                  status: r.success ? 'pending' : 'failed',
                  progress: 0,
                  message: r.message || ''
                }
              })
              this.batchPhase = 'deploying'
              this.$message.success(`批量下发完成：成功 ${res.data.succeeded} 台，失败 ${res.data.failed} 台`)
              // 刷新设备列表，离线排队的设备显示「待升级」标签
              this.fetchDevices()
              this.checkBatchFinished()
            } else {
              this.$message.error(res.message || '批量下发失败')
            }
          })
          .catch(error => {
            this.$message.error('批量下发失败：' + (error.response?.data?.message || error.message))
          })
          .finally(() => {
            this.batchDeploying = false
          })
      }).catch(() => {})
    },

    // 批量进度条状态：失败红色、成功绿色、进行中蓝色(null)
    batchProgressStatus(status) {
      if (status === 'failed') return 'exception'
      if (status === 'success') return 'success'
      return null
    },

    // 取消设备的待升级任务（离线排队中的升级）
    handleCancelUpgrade(row) {
      this.$confirm(
        `确定取消设备「${row.name}」的待升级任务吗？取消后设备上线将不会自动升级。`,
        '取消升级',
        { confirmButtonText: '确定取消', cancelButtonText: '返回', type: 'warning' }
      ).then(async () => {
        try {
          const res = await api.cancelOta(row.pendingRecordId)
          if (res.success) {
            this.$message.success('已取消待升级任务')
            this.fetchDevices()
          } else {
            this.$message.error(res.message || '取消失败')
          }
        } catch (error) {
          this.$message.error('取消失败：' + (error.response?.data?.message || error.message))
        }
      }).catch(() => {})
    },

    // 检查批量升级是否全部结束（成功/失败/已取消/已是最新），结束后汇总提示并刷新列表
    checkBatchFinished() {
      if (this.batchFinishedNotified || this.batchProgressList.length === 0) return
      const terminal = ['success', 'failed', 'already_latest', 'cancelled']
      const done = this.batchProgressList.every(r => terminal.includes(r.status))
      if (done) {
        this.batchFinishedNotified = true
        const successCount = this.batchProgressList.filter(r => r.status === 'success').length
        const otherCount = this.batchProgressList.length - successCount
        if (otherCount > 0) {
          this.$message.warning(`批量升级结束：成功 ${successCount} 台，未成功 ${otherCount} 台`)
        } else {
          this.$message.success(`批量升级结束：全部 ${successCount} 台升级成功`)
        }
        // 清空勾选并刷新设备列表（版本号已在 WebSocket 中实时更新）
        if (this.$refs.deviceTable) {
          this.$refs.deviceTable.clearSelection()
        }
        this.fetchDevices()
      }
    },

    // WebSocket 推送的升级进度
    handleOtaProgress(msg) {
      // 批量升级：更新对应设备的进度行
      if (this.batchOtaDialogVisible && this.batchProgressList.length > 0) {
        const row = this.batchProgressList.find(r => String(r.deviceId) === String(msg.deviceId))
        if (row) {
          if (msg.status) this.$set(row, 'status', msg.status)
          this.$set(row, 'progress', msg.progress || 0)
          if (msg.message) this.$set(row, 'message', msg.message)
          if (msg.status === 'success') {
            this.$set(row, 'progress', 100)
            if (msg.version) {
              this.$set(row, 'message', '升级成功，当前版本 v' + msg.version)
              // 同步设备列表版本号
              const idx = this.deviceList.findIndex(d => String(d.id) === String(msg.deviceId))
              if (idx >= 0) {
                this.$set(this.deviceList[idx], 'firmwareVersion', msg.version)
              }
            }
          }
          this.checkBatchFinished()
          return
        }
      }
      // 单设备升级进度
      if (this.otaDialogVisible && String(msg.deviceId) === String(this.otaForm.deviceId)) {
        this.otaProgress.show = true
        this.otaProgress.status = msg.status || ''
        this.otaProgress.progress = msg.progress || 0
        this.otaProgress.message = msg.message || ''

        if (msg.status === 'success') {
          this.otaDeploying = false
          this.otaProgress.progress = 100
          this.$message.success('设备升级成功，当前版本 v' + msg.version)
          if (msg.version) {
            this.otaForm.currentVersion = msg.version
          }
          // 刷新设备列表以更新版本号列
          this.fetchDevices()
          this.fetchOtaRecords(this.otaForm.deviceId)
        } else if (msg.status === 'failed') {
          this.otaDeploying = false
          this.$message.error('升级失败：' + (msg.message || ''))
          this.fetchOtaRecords(this.otaForm.deviceId)
        } else if (msg.status === 'already_latest') {
          this.otaDeploying = false
          this.$message.info('设备已是目标版本，无需升级')
          this.fetchOtaRecords(this.otaForm.deviceId)
        } else if (msg.status === 'cancelled') {
          this.otaDeploying = false
          this.otaProgress.show = false
          this.$message.info('升级任务已取消')
          this.fetchOtaRecords(this.otaForm.deviceId)
        }
        return
      }
      // 升级对话框未打开（或非当前设备）时，全局弹窗提示关键升级事件，
      // 避免关闭页面后离线排队升级的进展无处可见
      this.notifyOtaEvent(msg)
    },

    // 对话框关闭时的全局升级事件通知
    notifyOtaEvent(msg) {
      const device = this.deviceList.find(d => String(d.id) === String(msg.deviceId))
      const label = device ? device.name : (msg.serialNumber || ('设备 ' + msg.deviceId))
      if (msg.status === 'success') {
        if (msg.version && device) {
          this.$set(device, 'firmwareVersion', msg.version)
        }
        this.$notify.success({
          title: 'OTA 升级成功',
          message: `${label} 已升级到 v${msg.version || ''}`,
          duration: 6000
        })
      } else if (msg.status === 'failed') {
        this.$notify.error({
          title: 'OTA 升级失败',
          message: `${label}：${msg.message || '升级失败'}`,
          duration: 8000
        })
      } else if (msg.status === 'rebooting') {
        this.$notify.info({
          title: 'OTA 升级',
          message: `${label} 固件校验通过，设备重启中`,
          duration: 5000
        })
      } else if (msg.status === 'already_latest') {
        this.$notify.info({
          title: 'OTA 升级',
          message: `${label} 已是目标版本，无需升级`,
          duration: 5000
        })
      } else if (msg.status === 'pending' && msg.message && msg.message.indexOf('已上线') >= 0) {
        this.$notify.info({
          title: 'OTA 自动升级',
          message: `${label} 已上线，开始自动升级`,
          duration: 5000
        })
      }
    },

    otaRecordStatusText(status) {
      const map = {
        pending: '待响应',
        upgrading: '升级中',
        rebooting: '重启中',
        success: '升级成功',
        failed: '升级失败',
        cancelled: '已取消',
        already_latest: '已是最新'
      }
      return map[status] || status
    },

    otaRecordTagType(status) {
      const map = {
        pending: 'primary',
        upgrading: 'primary',
        rebooting: 'warning',
        success: 'success',
        failed: 'danger',
        cancelled: 'info',
        already_latest: 'info'
      }
      return map[status] || 'primary'
    },

    formatFileSize(bytes) {
      if (!bytes) return '-'
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
      return (bytes / 1024 / 1024).toFixed(2) + ' MB'
    }
  },

}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.danger-text {
  color: #F56C6C;
}

/* 设备详情抽屉样式 */
.device-detail {
  padding: 20px;
  background-color: #f5f7fa;
  height: 100%;
  overflow-y: auto;
}

.device-basic-info {
  margin-bottom: 30px;
}

.device-basic-info h3 {
  margin-bottom: 15px;
  color: #303133;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: 2px solid #409eff;
}

.device-sensor-data {
  margin-top: 30px;
}

.device-members {
  margin-top: 30px;
}

.device-members h3 {
  margin-bottom: 15px;
  color: #303133;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: 2px solid #409eff;
}

.device-members .el-table {
  margin-top: 10px;
}

.device-sensor-data h3 {
  margin-bottom: 15px;
  color: #303133;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: 2px solid #409eff;
}

/* 美化表格 */
.device-sensor-data .el-table {
  margin-top: 10px;
}

/* 历史查询样式 */
.history-filter {
  margin-bottom: 20px;
}

.history-content {
  min-height: 200px;
}

.history-chart {
  width: 100%;
  background-color: #fafafa;
  border-radius: 4px;
}
</style>
.device-sensor-data .el-table th {
  background-color: #ecf5ff;
  color: #303133;
  font-weight: bold;
}

/* 美化描述列表 */
.device-basic-info .el-descriptions__label {
  font-weight: bold;
  color: #606266;
}

.device-basic-info .el-descriptions__content {
  color: #303133;
}

/* 美化空状态 */
.device-sensor-data .el-empty {
  margin-top: 50px;
}

/* 密码容器样式 */
.password-container {
  display: flex;
  align-items: center;
}

.password-container span {
  margin-right: 10px;
}
</style>
